<template>
  <v-card class="pa-2" flat>
    <!-- بخش انتخاب فایل اولیه -->
    <template v-if="!showUploadBtn && !onChange">
      <v-card-text class="pa-0">
        <v-file-input
          ref="fileInput"
          v-model="filesModel"
          :loading="loading"
          accept="video/mp4"
          class="d-none"
          clearable
          truncate-length="7"
          @change="handleFileUpload"
          @click:clear="filesModel = null"
        />
      </v-card-text>

      <v-card
        id="uploader"
        ref="uploader"
        :loading="loading"
        class="mx-auto d-flex justify-center align-center rounded-xl flex-column overflow-hidden"
        height="200"
        max-width="700"
        outlined
        @click="dragEvent"
        @dragleave="dragEvent"
        @dragover="dragEvent"
        @drop="dragEvent"
      >
        <v-icon size="68" style="opacity: 0.4">mdi-cloud-upload-outline</v-icon>
        <v-card-title class="justify-center">{{ $t("upload_file") }}</v-card-title>
        <v-card-text class="text-center pt-0">
          {{ $t("drag_and_drop_to_upload_or") }}
          <v-btn :loading="loading" class="mx-1" color="primary" min-width="75" small>
            {{ $t("here") }}
          </v-btn>
          {{ $t("click") }}
        </v-card-text>
      </v-card>
    </template>

    <!-- بخش پیش‌نمایش، پیشرفت آپلود و فرم اطلاعات -->
    <template v-else-if="!!filesModel || (!!value && !!value.images && !!value.images.length)">
      <v-card class="d-flex flex-wrap mx-auto pa-2" flat>
        <v-row justify="center" no-gutters>
          <v-col
            class="text-center d-flex flex-column pa-2 position-relative"
            cols="12"
            md="4"
            style="max-width: 300px; width: 300px"
          >
            <!-- اطلاعات پیشرفت آپلود -->
            <div v-if="upLoading" class="mb-2 text-right w-100" style="font-size: 12px;">
              درحال بارگذاری ویدیو...
              <br/>
              <span class="text-muted">{{ formatMB(uploadedSize) }} مگ از {{ formatMB(totalSize) }} مگ</span>
            </div>

            <div class="position-relative">
              <video controls muted width="100%">
                <source :src="filesPreview.url" type="video/mp4" />
                مرورگر شما از تگ ویدیو پشتیبانی نمی‌کند.
              </video>
              
              <v-progress-linear
                v-if="upLoading"
                :value="progress"
                height="10"
                color="info"
                class="mt-1"
              ></v-progress-linear>
              <div v-if="upLoading" class="text-right w-100 mt-1">
                <v-chip color="info" small dark>{{ progress }}%</v-chip>
              </div>
            </div>

            <div v-if="!upLoading && !filesPreview.color" class="d-flex flex-nowrap justify-space-between w-100 mt-2">
              <span class="pa-2 text-truncate">{{ filesPreview.name }}</span>
              <v-btn icon @click="cancelUpload">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </div>

            <v-card
              v-else-if="!!filesPreview.color"
              class="d-flex rounded-top-0 align-center justify-center pa-2 mt-2"
              :color="filesPreview.color === 'success' ? 'success' : 'error'"
              flat
              width="100%"
            >
              <v-avatar color="white">
                <v-icon :color="filesPreview.color">mdi-{{ !!filesPreview.status ? "check" : "close" }}</v-icon>
              </v-avatar>
            </v-card>
          </v-col>

          <!-- فرم اطلاعات ویدیو -->
          <v-col class="pa-2" cols="12" md="8">
            <suggest-text v-model="filesPreview.name" class="my-2" label="عنوان ویدیو *" rows="1" />
            <suggest-text v-model="filesPreview.description" class="my-2" label="توضیحات ویدیو *" />

            <v-card outlined class="pa-2 my-2">
              <v-row no-gutters align="center">
                <v-col cols="12">
                  <v-text-field
                    v-model="tempTag"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    hide-details
                    label="برچسب‌های ویدیو (حداقل ۳، حداکثر ۵ مورد) *"
                    outlined
                    @keydown.enter="addTag"
                  >
                    <template v-slot:append>
                      <v-btn class="mt-n1" color="primary" small text @click="addTag">
                        <v-icon>mdi-plus</v-icon> افزودن
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="mt-2 d-flex align-center justify-space-between">
                  <div>
                    <v-chip
                      v-for="(tag, i) in filesPreview?.tag"
                      :key="i"
                      class="ma-1"
                      close
                      small
                      @click:close="removeTag(i)"
                    >
                      {{ tag }}
                    </v-chip>
                  </div>
                  <span class="text-caption text-muted">{{ filesPreview?.tag?.length || 0 }} / ۵</span>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-card>

      <!-- دکمه‌های عملیات -->
      <v-card-actions class="justify-left pa-4">
        <!-- دکمه نهایی ثبت (فقط وقتی آپلود تمام شده و فرم پر است فعال می‌شود) -->
        <v-btn
          v-if="showUploadBtn"
          :disabled="!canSubmitFinal"
          class="rounded-lg btn-get-code"
          depressed
          min-width="150"
          @click="submitFinalVideo"
        >
          {{ upLoading ? 'درحال آپلود فایل...' : 'افزودن ویدیو' }}
          <v-icon left v-if="!upLoading">mdi-chevron-left</v-icon>
        </v-btn>
        
        <v-btn v-if="upLoading" depressed class="btn-delete rounded-lg" @click="cancelUpload">
          <v-icon left>mdi-stop</v-icon>
          توقف آپلود
        </v-btn>
        
        <v-btn v-if="!upLoading" @click="cancelUpload" class="btn-delete rounded-lg">
          <v-icon left>mdi-close</v-icon>
          انصراف
        </v-btn>
      </v-card-actions>
    </template>
  </v-card>
</template>

<script>
import SuggestText from "@/view/components/SuggestBox/suggestInput";

export default {
  name: "videoUploadHandler",
  components: { SuggestText },
  props: {
    value: [Array, Object],
    onChange: Boolean,
  },
  data: () => ({
    filesModel: null,
    filesPreview: {
      tag: [],
      name: "",
      description: "",
      url: "",
      src: "",
      status: false,
      color: ""
    },
    loading: false,
    upLoading: false,
    uploadCompleted: false, // متغیر جدید برای بررسی اتمام آپلود فایل
    isCancelled: false,
    progress: 0,
    uploadedSize: 0,
    totalSize: 0,
    tempTag: "",
    chunkSize: 3000000, 
    uuID: null,
  }),
  computed: {
    computedValue: {
      get() { return this.onChange ? this.value : this.filesModel; },
      set(val) { this.filesModel = val; },
    },
    showUploadBtn() { return !!this.computedValue; },
    // شرط فعال شدن دکمه نهایی: آپلود تمام شده باشد + فرم معتبر باشد
    canSubmitFinal() {
      return (
        this.uploadCompleted === true &&
        !!this.filesPreview?.name &&
        this.filesPreview?.description?.length >= 3 &&
        this.filesPreview?.tag?.length >= 3 &&
        this.filesPreview?.tag?.length <= 5
      );
    },
  },
  watch: {
    value(val) {
      this.filesModel = val;
      this.handleFileUpload(val);
    }
  },
  methods: {
    async getConfig() {
      try {
        const response = await this.$api.get('/user/aparat/upload/conf');
        let data = response.data.data;
        this.chunkSize = data.chuck_size;
        this.uuID = data.uuid;
      } catch (error) {
        if(this.$toast) this.$toast.error("خطا در دریافت تنظیمات آپلود.");
      }
    },
    formatMB(bytes) {
      return (bytes / (1024 * 1024)).toFixed(2);
    },
    addTag() {
      if (!this.tempTag.trim()) return;
      if (this.filesPreview.tag.length >= 5) {
        if(this.$toast) this.$toast.error("حداکثر ۵ برچسب مجاز است.");
        return;
      }
      if (!this.filesPreview.tag.includes(this.tempTag.trim())) {
        this.filesPreview.tag.push(this.tempTag.trim());
      }
      this.tempTag = "";
    },
    removeTag(index) {
      this.filesPreview.tag.splice(index, 1);
    },
    dragEvent(e) {
      e.stopPropagation(); e.preventDefault();
      let uploader = this.$refs.uploader;
      if (e.type === "dragover" && !uploader.$el.classList.contains("drag-over"))
        uploader.$el.classList.add("drag-over");
      else if (e.type === "dragleave" && uploader.$el.classList.contains("drag-over"))
        uploader.$el.classList.remove("drag-over");
      else if (e.type === "drop") {
        uploader.$el.classList.remove("drag-over");
        const files = e.target.files || e.dataTransfer.files;
        this.filesModel = files;
        this.handleFileUpload(files);
      } else if (e.type === "click") {
        this.$refs.fileInput.$refs.input.click();
      }
    },
    handleFileUpload(event) {
      if (!event) {
        this.resetPreview();
        return;
      }
      const files = Array.isArray(event) ? event : [event];
      if (files.length === 0 || !(files[0] instanceof File)) {
        this.resetPreview();
        return;
      }
      const file = files[0];
      
      const videoUrl = URL.createObjectURL(file);
      
      this.filesPreview = {
        src: videoUrl,
        url: videoUrl,
        name: file.name || "",
        description: "",
        tag: [],
        status: false,
        color: ""
      };
      
      this.uploadCompleted = false; 
      this.$forceUpdate();

      this.uploadToServer(file);
    },
    resetPreview() {
      this.filesPreview = { tag: [], name: "", description: "", url: "", src: "", status: false, color: "" };
    },
    cancelUpload() {
      this.isCancelled = true;
      
      if (this.uuID && this.upLoading) {
        this.$api.delete('/user/aparat/upload/cancel', { data: { uuid: this.uuID } })
          .then(() => {
            this.clearUploadState();
            if(this.$toast) this.$toast.success("آپلود فایل شما متوقف شد");
          }).catch(() => {
            this.clearUploadState(); 
            if(this.$toast) this.$toast.error("خطا در توقف آپلود ویدئو رخ داد.");
          });
      } else {
        this.clearUploadState();
      }
    },
    clearUploadState() {
      this.filesModel = null;
      if (this.onChange) this.$emit("input", "");
      this.resetPreview();
      this.progress = 0;
      this.upLoading = false;
      this.isCancelled = false;
      this.uploadCompleted = false;
    },
    
    async uploadToServer(file) {
      await this.getConfig();
      if (!this.uuID) return; 

      this.upLoading = true;
      this.isCancelled = false;
      this.uploadCompleted = false;
      this.progress = 0;
      this.totalSize = file.size;
      this.uploadedSize = 0;
      
      const totalParts = Math.ceil(file.size / this.chunkSize);

      for (let index = 0; index < totalParts; index++) {
        if (this.isCancelled) {
          this.upLoading = false;
          return;
        }

        const offset = index * this.chunkSize;
        const chunkEnd = Math.min(offset + this.chunkSize, file.size);
        const chunk = file.slice(offset, chunkEnd);

        const success = await this.uploadChunk(chunk, index, offset, totalParts, file);
        
        if (!success) {
          if (this.isCancelled) return;
          this.upLoading = false;
          this.filesPreview.status = false;
          this.filesPreview.color = "error";
          if(this.$toast) this.$toast.error("خطا در آپلود قطعه‌ای از ویدئو!");
          return; 
        }

        this.uploadedSize = chunkEnd;
        this.progress = Math.round((this.uploadedSize / this.totalSize) * 100);
      }

      if (this.isCancelled) return;

      this.upLoading = false;
      this.uploadCompleted = true; 
      this.filesPreview.status = true;
      this.filesPreview.color = "success";
      if(this.$toast) this.$toast.success("آپلود فایل تمام شد. لطفا اطلاعات ویدیو را تکمیل و تایید کنید.");
    },

    async uploadChunk(chunk, index, offset, totalParts, file) {
      const ext = file.name.split('.').pop();
      const formData = new FormData();
      formData.append("file", chunk);
      formData.append("chunk_index", index);
      formData.append("total_chunks", totalParts);
      formData.append("qqtotalfilesize", file.size);
      formData.append("uuid", this.uuID);
      formData.append("ext", ext);
      formData.append("total_size",this.totalSize);
      formData.append("offset",offset);

      try {
        await this.$api.post("/user/aparat/upload", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });
        return true;
      } catch (error) {
        return false;
      }
    },

    async submitFinalVideo() {
      const file = this.filesModel instanceof Array ? this.filesModel[0] : this.filesModel;
      const ext = file ? file.name.split('.').pop() : 'mp4';

      const formData = new FormData();
      formData.append("title", this.filesPreview.name);
      formData.append("description", this.filesPreview.description);
      formData.append("tag", this.filesPreview.tag.join("-"));
      formData.append("uuid", this.uuID);
      formData.append("ext", ext);
      
      try {
        await this.$api.post("/user/aparat", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });
        if(this.$toast) this.$toast.success("ویدیو با موفقیت منتشر شد.");
      } catch (error) {
        this.filesPreview.color = "error";
        if(this.$toast) this.$toast.error("ارسال اطلاعات ویدیو با خطا روبرو شد.");
        return false;
      }
  
      setTimeout(() => {
        if (!this.onChange) {
           this.filesModel = null;
           this.resetPreview();
           this.uploadCompleted = false;
        }
        this.$emit("fetch");
      }, 1000);
    }
  },
};
</script>

<style scoped>
#uploader {
  transition: all 0.3s ease;
  background-color: rgba(0, 0, 0, 0.2);
  border: 2px dashed #5b5b5b !important;
}
.drag-over {
  border: 2px dashed #fff !important;
  background-color: rgba(33, 150, 243, 0.33) !important;
}
.position-relative {
  position: relative;
}
</style>
